import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  alertModalContent: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
  card: {
    alignItems: 'center',
    flex: 1,
  },
  changeLocationButton: {
    marginTop: Theme.px(15),
  },
  helpText: {
    marginTop: Theme.px(26),
    textAlign: 'center',
  },
  locationText: {
    lineHeight: Theme.px(48),
    paddingVertical: Theme.px(46),
    textAlign: 'center',
  },
  titleText: {
    lineHeight: Theme.px(48),
    paddingHorizontal: Theme.px(60),
    textAlign: 'center',
  },
});
